import inView from 'in-view';
import staticSizes from 'DesignSystem/layout/static-sizes';
import timing from 'DesignSystem/motion/timing';

const listPager = (_options:{
  cssClass?:string,
  cssClassDefault?: string,
  cssClassItem?:string,
}) => {
  const opt = {
    cssClass: '.ListPager',
    cssClassDefault: 'ListPager',
    cssClassItem: '.ListPager-item',
    ..._options
  };
  const target: string = opt.cssClass;
  const targets: any = document.querySelectorAll(target);

  for (const elt of targets) {

    // test if element is init
    if (elt.dataset[`init${opt.cssClassDefault}`]) {
      return true; // already init go to next iteration
    }
    // init element
    elt.dataset[`init${opt.cssClassDefault}`] = true;

    const items: any = elt.querySelectorAll(opt.cssClassItem);
    inView.offset(staticSizes.params['in-view'].offset.mobile);
    inView(opt.cssClass)
      .on('enter', ()=>{
        elt.classList.add('isInViewport');

        for (const item of items) {
          item.style.animationDelay = `${timing.params.slow / items.length * Array.prototype.indexOf.call(items, item)}ms`;
        }
      });
  }
};

export default listPager;
